<template>
  <r-panel :disabled="disabled" :title="title" :empty="items.length === 0" :button_add="true" @click_add="click_add">
    <r-card-package-table ref="table" :items.sync="values" :toolbar="false" :duplicate="true"/>
  </r-panel>
</template>

<script>
import VueTypes from "vue-types";

import RPanel from "@/modules/redactor/views/utils/r-panel.vue";
import RCardPackageTable from "@/modules/redactor/views/card-package/r-card-package-table.vue";

export default {
  name: "r-card-package-panel",
  components: {RCardPackageTable, RPanel},
  props: {
    disabled: VueTypes.bool.def(false),
    title: VueTypes.string.def("Card Packages"),
    items: VueTypes.arrayOf(VueTypes.string) //CardPackageModel_UID
  },
  computed: {
    values() {
      if (this.items) {
        return this.items;
      } else {
        let values = [];
        this.$emit("update:items", values);
        return values;
      }
    }
  },
  methods: {
    click_add() {
      this.$refs["table"].row_create();
    }
  }
}

</script>
